export enum EShapes {
  Round = 'round',
  Default = 'default'
}
